// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1Z1up","title":"styles_title__2a_3W","subtitle":"styles_subtitle__1Idms"};